import v from './Variables';

function borderColors() {
  let styles = '';

  Object.keys(v.colors).forEach((key) => {
    styles += `
       .border--${key} {

         border-color: ${(v.colors as any)[key]} !important;
       }
     `;
  });

  return styles;
}

export default borderColors;
